/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react'; // @ts-ignore
// eslint-disable-next-line @typescript-eslint/camelcase

import { search_16 } from '@trustpilot/icons';
import { IconButton } from '../button';
import { inputStyles } from './input';
import { motion } from 'framer-motion';
import { Search as SearchInput } from '../../../Search'; // https://stackoverflow.com/questions/37949981/call-child-method-from-parent

export var Search = React.forwardRef(function (_a, ref) {
  var _b = _a.openByDefault,
      openByDefault = _b === void 0 ? false : _b,
      defaultValue = _a.defaultValue,
      onSubmit = _a.onSubmit,
      updateCount = _a.updateCount,
      placeholder = _a.placeholder;

  var _c = React.useState(openByDefault),
      opened = _c[0],
      setOpened = _c[1];

  var _d = React.useState(defaultValue),
      value = _d[0],
      setValue = _d[1];

  var _e = React.useState(0),
      _count = _e[0],
      setCount = _e[1];

  var inputRef = React.createRef();

  function submit() {
    if (!value) {
      setCount(0);
    } else {
      setCount(1);
    }

    onSubmit(value);

    if (inputRef.current) {
      inputRef.current.focus();
    }
  }

  React.useEffect(function () {
    setOpened(openByDefault);
  }, [openByDefault]);
  React.useEffect(function () {
    if (!defaultValue) {
      setCount(0);
    } else {
      setCount(1);
    }

    setValue(defaultValue);
  }, [defaultValue]);
  React.useEffect(function () {
    updateCount();
  }, [_count, updateCount]);
  React.useImperativeHandle(ref, function () {
    return {
      count: function count() {
        return _count;
      }
    };
  });
  /* eslint-disable @typescript-eslint/camelcase */

  return jsx("div", {
    css: {
      marginRight: 8,
      paddingBottom: 12
    }
  }, jsx(motion.div, {
    initial: opened ? 'hidden' : 'visible',
    animate: opened ? 'hidden' : 'visible',
    variants: {
      hidden: {
        opacity: 0,
        display: 'none'
      },
      visible: {
        opacity: 1,
        display: 'block'
      }
    }
  }, jsx(IconButton, {
    icon: search_16,
    onClick: function onClick() {
      setOpened(function (o) {
        return !o;
      });

      if (inputRef.current) {
        inputRef.current.focus();
      }
    },
    dataTestId: "expand-search"
  })), jsx(motion.div, {
    css: {
      width: ['auto', 'auto', '100%']
    },
    initial: opened ? 'visible' : 'hidden',
    animate: opened ? 'visible' : 'hidden',
    variants: {
      hidden: {
        opacity: 0,
        width: 0,
        display: 'none'
      },
      visible: {
        opacity: 1,
        width: '100%',
        display: 'block'
      }
    }
  }, jsx(SearchInput, {
    css: inputStyles(_count > 0 && value !== ''),
    ref: inputRef,
    placeholder: placeholder ? placeholder : '',
    size: "small",
    onSubmit: submit,
    onChange: function onChange(e) {
      return setValue(e.target.value);
    },
    value: value || ''
  })));
  /* eslint-enable */
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/search/index.js
// module id = 1025
// module chunks = 0